import {inject} from "@angular/core";
import {CanActivateFn, Router} from "@angular/router";
import {Store} from "@ngrx/store";
import {lastValueFrom, take} from "rxjs";
import {environment} from "../../../environments/environment";
import {APP_CONSTANTS} from "../../app.constants";
import {setIsUser} from "../../store/actions/auth.actions";
import {selectIsUser, selectUserRoles} from "../../store/reducers/auth.reducer";

export const userGuard: CanActivateFn = async () => {
  const store: Store = inject(Store);
  const router: Router = inject(Router);

  const isUser = await lastValueFrom(store.select(selectIsUser).pipe(take(1)));

  if (isUser === null) {
    const roles = await lastValueFrom(store.select(selectUserRoles).pipe(take(1)));

    if (roles === null) {
      await router.navigate([APP_CONSTANTS.UNAUTHORISED_ROUTE]);
      return false;
    }

    const authorised =
      roles.filter(value => value === environment.userGroupName || value === environment.adminGroupName).length > 0;

    if (authorised) {
      store.dispatch(setIsUser({isUser: true}));
      return true;
    } else {
      store.dispatch(setIsUser({isUser: false}));
      await router.navigate([APP_CONSTANTS.UNAUTHORISED_ROUTE]);
      return false;
    }
  }

  return isUser;
};
